import React from 'react';

/**
 * Badge pour afficher un raccourci clavier
 * @param {string} shortcut - Le texte du raccourci (ex: "⌘+K", "Ctrl+K", "Esc")
 * @param {React.Component} icon - L'icône React à afficher (optionnel)
 * @param {string} size - Taille du badge: 'sm', 'md', 'lg'
 * @param {string} variant - Style du badge: 'default', 'primary', 'ghost'
 */
const KeyboardShortcutBadge = ({ 
    shortcut, 
    icon: Icon, 
    size = 'md',
    variant = 'default',
    className = ''
}) => {
    const sizeClasses = {
        'sm': 'px-1.5 py-0.5 text-[10px]',
        'md': 'px-2 py-1 text-xs',
        'lg': 'px-2.5 py-1.5 text-sm'
    };

    const variantClasses = {
        'default': 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 border border-gray-300 dark:border-gray-600',
        'primary': 'bg-gradient-to-br from-indigo-50 to-indigo-100 dark:from-indigo-900/30 dark:to-indigo-800/30 text-indigo-600 dark:text-indigo-300 border border-indigo-300 dark:border-indigo-600',
        'ghost': 'bg-white/80 dark:bg-gray-900/80 text-gray-500 dark:text-gray-400 border border-gray-200 dark:border-gray-700 backdrop-blur-sm'
    };

    return (
        <kbd 
            className={`
                inline-flex items-center gap-1 
                font-semibold rounded shadow-sm
                select-none pointer-events-none
                ${sizeClasses[size]}
                ${variantClasses[variant]}
                ${className}
            `}
        >
            {Icon && <Icon className="text-[10px]" />}
            <span className="tracking-tight">{shortcut}</span>
        </kbd>
    );
};

export default KeyboardShortcutBadge;
